// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__1qiKv","pokemonCard":"styles_pokemonCard__39XCJ"};